export class CostReviewBuildingLevelNetworkPanels {
  isBuildingLevelNetworkPanelsApplicableLessThanThreshold!: boolean;
  isBuildingLevelNetworkPanelsApplicable!: boolean;
  numberOfBuildingLevelNetworks!: number;
  fieldPanelProductName!: string;
  numberOfFieldPanelDrivers!: number;
  equipmentManagedByPanelDrivers!: string;
  sparePanelCapacity!: number;
  networkBy!: number;
  networkHardwareIncluded!: number;
  networkSpecificationsReviewed!: number;
  fiberOpticsRequired!: number;
}
